import React, {useState, Fragment} from 'react'
import {CheckIcon, SelectorIcon} from "@heroicons/react/solid";
import {Listbox, Transition} from "@headlessui/react";

import "../../assets/hint.min.css"

const tabs = [
    {id: 0, name: 'Teams'},
    {id: 1, name: 'Players'},
    {id: 2, name: 'Champions'}
]

const stats = [
    {
        team: 'Zort',
        gp: 16,
        w: 9,
        l: 7,
        avgd: 31.3,
        k: 222,
        d: 121,
        kd: 1.06,
        avg: 0.86,
        ckpm: 0.86,
        gpr: 1.00,
        gspd: 3.6,
        avgg: 3.6,
        g15: 3.6,
        gd15: 25.556,
        avgt15: 0.81,
        avgtd15: 0.63,
        avgd15: 1.25,
        fb: 50,
        ft: 25,
        ft3t: 44,
        pdpg: 4.9,
        hcr: 44,
        fd: 44,
        dcr: 44,
        eld: 44,
        fbr: 44,
        bcr: 44,
        lnc: 50,
        jnc: 50,
        wpm: 3.24,
        cwpm: 1.16,
        wcpm: 1.40
    },
    {
        team: 'Zart',
        gp: 16,
        w: 9,
        l: 7,
        avgd: 31.3,
        k: 222,
        d: 121,
        kd: 1.06,
        avg: 0.86,
        ckpm: 0.86,
        gpr: 1.00,
        gspd: 3.6,
        avgg: 3.6,
        g15: 3.6,
        gd15: 25.556,
        avgt15: 0.81,
        avgtd15: 0.63,
        avgd15: 1.25,
        fb: 50,
        ft: 25,
        ft3t: 44,
        pdpg: 4.9,
        hcr: 44,
        fd: 44,
        dcr: 44,
        eld: 44,
        fbr: 44,
        bcr: 44,
        lnc: 50,
        jnc: 50,
        wpm: 3.24,
        cwpm: 1.16,
        wcpm: 1.40
    },
    {
        team: 'Hort',
        gp: 16,
        w: 9,
        l: 7,
        avgd: 31.3,
        k: 222,
        d: 121,
        kd: 1.06,
        avg: 0.86,
        ckpm: 0.86,
        gpr: 1.00,
        gspd: 3.6,
        avgg: 3.6,
        g15: 3.6,
        gd15: 25.556,
        avgt15: 0.81,
        avgtd15: 0.63,
        avgd15: 1.25,
        fb: 50,
        ft: 25,
        ft3t: 44,
        pdpg: 4.9,
        hcr: 44,
        fd: 44,
        dcr: 44,
        eld: 44,
        fbr: 44,
        bcr: 44,
        lnc: 50,
        jnc: 50,
        wpm: 3.24,
        cwpm: 1.16,
        wcpm: 1.40
    },
    {
        team: 'Hop',
        gp: 16,
        w: 9,
        l: 7,
        avgd: 31.3,
        k: 222,
        d: 121,
        kd: 1.06,
        avg: 0.86,
        ckpm: 0.86,
        gpr: 1.00,
        gspd: 3.6,
        avgg: 3.6,
        g15: 3.6,
        gd15: 25.556,
        avgt15: 0.81,
        avgtd15: 0.63,
        avgd15: 1.25,
        fb: 50,
        ft: 25,
        ft3t: 44,
        pdpg: 4.9,
        hcr: 44,
        fd: 44,
        dcr: 44,
        eld: 44,
        fbr: 44,
        bcr: 44,
        lnc: 50,
        jnc: 50,
        wpm: 3.24,
        cwpm: 1.16,
        wcpm: 1.40
    }
]

const splits = [
    {id: 0, name: "TCL"},
    {id: 1, name: "TCL Academy"},
    {id: 2, name: "LCS"},
    {id: 3, name: "LEC"}
]

const leagues = [
    {id: 0, name: "Winter 2022"},
    {id: 1, name: "Summer 2021 Playoffs"},
    {id: 2, name: "Summer 2021"},
    {id: 3, name: "Winter 2021 Playoffs"}
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function Analytics() {
    const [type, setType] = useState(0)
    const [selectedSplit, setSelectedSplit] = useState(splits[0])
    const [selectedLeague, setSelectedLeague] = useState(leagues[0])

    return (
        <div className="flex flex-col gap-y-6 h-full">
            <div className="sm:hidden">
                <label htmlFor="tabs" className="sr-only">
                    Select a tab
                </label>

                <select
                    id="tabs"
                    name="tabs"
                    className="w-full pl-3 pr-10 py-2 text-base border-gray-300 transition-colors focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                    defaultValue={tabs.find((tab) => tab.id === type).name}
                    onChange={e => {
                        setType(tabs.find(tab => tab.name === e.target.value).id ?? 0)
                    }}
                >
                    {tabs.map((tab) => (
                        <option key={tab.name}>{tab.name}</option>
                    ))}
                </select>
            </div>

            <div className="hidden sm:block">
                <div className="border-b border-gray-200">
                    <nav className="-mb-px flex justify-between" aria-label="Tabs">
                        <div className="flex gap-x-8 items-center justify-center">
                            {tabs.map((tab) => (
                                <a
                                    key={tab.name}
                                    className={classNames(
                                        tab.id === type
                                            ? 'border-indigo-500 text-indigo-600'
                                            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                                        'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm cursor-pointer'
                                    )}
                                    onClick={() => {
                                        setType(tab.id)
                                    }}
                                    aria-current={tab.id === type ? 'page' : undefined}
                                >
                                    {tab.name}
                                </a>
                            ))}
                        </div>
                    </nav>
                </div>
            </div>

            <div className="flex gap-x-8">
                <div className="w-72">
                    <Listbox value={selectedSplit} onChange={setSelectedSplit}>
                        {({open}) => (
                            <>
                                <Listbox.Label className="block text-sm font-medium text-gray-700">Select a Split</Listbox.Label>
                                <div className="mt-1 relative">
                                    <Listbox.Button
                                        className="relative w-full bg-white border border-gray-300 transition-colors rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                                        <span className="block truncate">{selectedSplit.name}</span>
                                        <span
                                            className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                                                <SelectorIcon className="h-5 w-5 text-gray-400" aria-hidden="true"/>
                                        </span>
                                    </Listbox.Button>

                                    <Transition
                                        show={open}
                                        as={Fragment}
                                        leave="transition ease-in duration-100"
                                        leaveFrom="opacity-100"
                                        leaveTo="opacity-0"
                                    >
                                        <Listbox.Options
                                            className="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                                            {splits.map((person) => (
                                                <Listbox.Option
                                                    key={person.id}
                                                    className={({active}) =>
                                                        classNames(
                                                            active ? 'text-white bg-indigo-600' : 'text-gray-900',
                                                            'cursor-default select-none relative transition-colors py-2 pl-8 pr-4'
                                                        )
                                                    }
                                                    value={person}
                                                >
                                                    {({selected, active}) => (
                                                        <>
                                                            <span className={classNames(selectedSplit ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                                              {person.name}
                                                            </span>

                                                            {selected ? (
                                                                <span
                                                                    className={classNames(
                                                                        active ? 'text-white' : 'text-indigo-600',
                                                                        'absolute inset-y-0 left-0 flex items-center pl-1.5'
                                                                    )}
                                                                >
                                                                        <CheckIcon className="h-5 w-5" aria-hidden="true"/>
                                                                </span>
                                                            ) : null}
                                                        </>
                                                    )}
                                                </Listbox.Option>
                                            ))}
                                        </Listbox.Options>
                                    </Transition>
                                </div>
                            </>
                        )}
                    </Listbox>
                </div>

                <div className="w-72">
                    <Listbox value={selectedLeague} onChange={setSelectedLeague}>
                        {({open}) => (
                            <>
                                <Listbox.Label className="block text-sm font-medium text-gray-700">Select a League</Listbox.Label>
                                <div className="mt-1 relative">
                                    <Listbox.Button
                                        className="relative w-full bg-white border border-gray-300 transition-colors rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                                        <span className="block truncate">{selectedLeague.name}</span>
                                        <span
                                            className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                                                <SelectorIcon className="h-5 w-5 text-gray-400" aria-hidden="true"/>
                                        </span>
                                    </Listbox.Button>

                                    <Transition
                                        show={open}
                                        as={Fragment}
                                        leave="transition ease-in duration-100"
                                        leaveFrom="opacity-100"
                                        leaveTo="opacity-0"
                                    >
                                        <Listbox.Options
                                            className="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                                            {leagues.map((person) => (
                                                <Listbox.Option
                                                    key={person.id}
                                                    className={({active}) =>
                                                        classNames(
                                                            active ? 'text-white bg-indigo-600' : 'text-gray-900',
                                                            'cursor-default transition-colors select-none relative py-2 pl-8 pr-4'
                                                        )
                                                    }
                                                    value={person}
                                                >
                                                    {({selected, active}) => (
                                                        <>
                                                            <span className={classNames(selectedLeague ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                                              {person.name}
                                                            </span>

                                                            {selected ? (
                                                                <span
                                                                    className={classNames(
                                                                        active ? 'text-white' : 'text-indigo-600',
                                                                        'absolute inset-y-0 left-0 flex items-center pl-1.5'
                                                                    )}
                                                                >
                                                                        <CheckIcon className="h-5 w-5" aria-hidden="true"/>
                                                                </span>
                                                            ) : null}
                                                        </>
                                                    )}
                                                </Listbox.Option>
                                            ))}
                                        </Listbox.Options>
                                    </Transition>
                                </div>
                            </>
                        )}
                    </Listbox>
                </div>
            </div>

            {type === 0 && (
                <div className="flex flex-col">
                    <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                            <div className="shadow-sm overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-gray-50">
                                    <tr>
                                        <th
                                            aria-label="Takım verisidir."
                                            scope="col"
                                            className="hint--bottom-right px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            TEAM
                                        </th>
                                        <th
                                            aria-label="GP verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            GP
                                        </th>
                                        <th
                                            aria-label="W verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            W
                                        </th>
                                        <th
                                            aria-label="L verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            L
                                        </th>
                                        <th
                                            aria-label="AVGD verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            AVGD
                                        </th>
                                        <th
                                            aria-label="K verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            K
                                        </th>
                                        <th
                                            aria-label="D verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            D
                                        </th>
                                        <th
                                            aria-label="K/D verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            K/D
                                        </th>

                                        <th
                                            aria-label="CKPM verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            CKPM
                                        </th>
                                        <th
                                            aria-label="AVG verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            AVG
                                        </th>
                                        <th
                                            aria-label="CKPM verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            CKPM
                                        </th>
                                        <th
                                            aria-label="GPR verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            GPR
                                        </th>
                                        <th
                                            aria-label="GSPD verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            GSPD
                                        </th>
                                        <th
                                            aria-label="AVGG verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            AVGG
                                        </th>
                                        <th
                                            aria-label="G@15 verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            G@15
                                        </th>
                                        <th
                                            aria-label="GD@15 verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            GD@15
                                        </th>
                                        <th
                                            aria-label="AVGT@15 verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            AVGT@15
                                        </th>
                                        <th
                                            aria-label="AVGTD@15 verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            AVGTD@15
                                        </th>
                                        <th
                                            aria-label="AVGD@15 verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            AVGD@15
                                        </th>
                                        <th
                                            aria-label="FB% verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            FB%
                                        </th>
                                        <th
                                            aria-label="FT% verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            FT%
                                        </th>
                                        <th
                                            aria-label="FT3T% verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            FT3T%
                                        </th>
                                        <th
                                            aria-label="PDBG verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            PDBG
                                        </th>
                                        <th
                                            aria-label="HCR% verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            HCR%
                                        </th>
                                        <th
                                            aria-label="FD% verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            FD%
                                        </th>
                                        <th
                                            aria-label="DCR% verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            DCR%
                                        </th>
                                        <th
                                            aria-label="ELD% verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            ELD%
                                        </th>
                                        <th
                                            aria-label="FBR% verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            FBR%
                                        </th>
                                        <th
                                            aria-label="BCR% verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            BCR%
                                        </th>
                                        <th
                                            aria-label="LNC% verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            LNC%
                                        </th>
                                        <th
                                            aria-label="JNC% verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            JNC%
                                        </th>
                                        <th
                                            aria-label="WPM% verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            WPM%
                                        </th>
                                        <th
                                            aria-label="CWPM% verisidir."
                                            scope="col"
                                            className="hint--bottom px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            CWPM%
                                        </th>
                                        <th
                                            aria-label="WCPM% verisidir."
                                            scope="col"
                                            className="hint--bottom-left px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            WCPM%
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                    {stats.map((person, index) => (
                                        <tr key={index}>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.team}
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.gp}
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.w}
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.l}
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.avgd}
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.k}
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.d}
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.kd}
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.avg}
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.ckpm}
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.avg}
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.gpr}
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.gspd}%
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.avgg}%
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.g15}%
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.gd15}
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.avgt15}
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.avgtd15}
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.avgd}
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.fb}%
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.ft}%
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.ft3t}%
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.pdpg}
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.hcr}%
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.fd}%
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.dcr}%
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.eld}%
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.fbr}%
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.bcr}%
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.lnc}%
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.jnc}%
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.wpm}
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.cwpm}
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {person.wcpm}
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {type === 1 && (
                <div className="flex flex-col">
                    <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                            <div className="shadow-sm overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-gray-50">
                                    <tr>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            Team
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            Rating
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            Date
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            Time
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            Map
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                    {stats.map((person) => (
                                        <tr key={person.nickname}>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="flex items-center">
                                                    <div className="flex-shrink-0 h-10 w-10">
                                                        <img className="h-10 w-10 rounded-full" src={person.image}
                                                             alt=""/>
                                                    </div>
                                                    <div className="ml-4">
                                                        <div
                                                            className="text-sm font-medium text-gray-900">{person.team}</div>
                                                        <div className="text-sm text-gray-500">{person.name}</div>
                                                    </div>
                                                </div>
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                            <span
                                                className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${person.rating <= 3 ? "bg-yellow-100 text-yellow-800" : "bg-green-100 text-green-800"}`}>
                                                {person.rating}/5
                                            </span>
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-gray-900">{person.date}</div>
                                            </td>


                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{person.time}</td>

                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{person.map}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {type === 2 && (
                <div className="flex flex-col">
                    <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                            <div className="shadow-sm overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-gray-50">
                                    <tr>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            Team
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            Rating
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            Date
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            Time
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider"
                                        >
                                            Map
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                    {stats.map((person) => (
                                        <tr key={person.nickname}>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="flex items-center">
                                                    <div className="flex-shrink-0 h-10 w-10">
                                                        <img className="h-10 w-10 rounded-full" src={person.image}
                                                             alt=""/>
                                                    </div>
                                                    <div className="ml-4">
                                                        <div
                                                            className="text-sm font-medium text-gray-900">{person.team}</div>
                                                        <div className="text-sm text-gray-500">{person.name}</div>
                                                    </div>
                                                </div>
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                            <span
                                                className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${person.rating <= 3 ? "bg-yellow-100 text-yellow-800" : "bg-green-100 text-green-800"}`}>
                                                {person.rating}/5
                                            </span>
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-gray-900">{person.date}</div>
                                            </td>


                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{person.time}</td>

                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{person.map}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
